<ng-container *ngIf="landingPage$ | async as page">
  <!--@defer (hydrate on idle) {-->
  <app-header-slider *ngIf="!page.header.simple; else defaultHeader" [headers]="(slides$ | async) ?? []"></app-header-slider>
  <!--}-->

  <ng-template #defaultHeader>
    <app-header-article
      [subtitle]="page.header.subtitle"
      [title]="page.header.title"
      [intro]="page.header.intro"
      [image]="page.header.image"
      [button]="page.header.button"
    ></app-header-article>
  </ng-template>

  <app-content-block-container [blocks]="page.contentBlocks"></app-content-block-container>
</ng-container>
